var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrorSolidSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.826 9.336L14.664 6.174C14.549 6.06436 14.3969 6.00221 14.238 6H9.762C9.60314 6.00221 9.45098 6.06436 9.336 6.174L6.174 9.336C6.06436 9.45098 6.00221 9.60314 6 9.762V14.238C6.00221 14.3969 6.06436 14.549 6.174 14.664L9.336 17.826C9.45098 17.9356 9.60314 17.9978 9.762 18H14.238C14.3969 17.9978 14.549 17.9356 14.664 17.826L17.826 14.664C17.9356 14.549 17.9978 14.3969 18 14.238V9.762C17.9978 9.60314 17.9356 9.45098 17.826 9.336Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8.83333C11 8.3731 11.4477 8 12 8C12.5523 8 13 8.3731 13 8.83333V12.1667C13 12.6269 12.5523 13 12 13C11.4477 13 11 12.6269 11 12.1667V8.83333ZM11 15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSolidSmall);
export default ForwardRef;